import React, { useState } from "react";
import "../CSS/AboutUs.css";
import { sendToWhatsApp } from "./utils/Whatsapp";
import ourstory from "../Img/our-story.png";
import contactFormBg from "../Img/contact-form-bg.png";
import {
  Phone,
  Mail,
  User,
  Smartphone,
  MessageCircle,
} from "lucide-react";
import reason from "../Img/reasons.png";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    inquiry: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `New request Form Submission from About Us page:\n\n*Name:* ${formData.name}\n*Phone:* ${formData.phone}\n*Email:* ${formData.email}\n*Inquiry:* ${formData.inquiry}`;
    sendToWhatsApp(message);
    setFormData({ name: '', phone: '', email: '', inquiry: '' });
  };
  return (
    <div className="about-us-page">
      {/* Hero Section - Only Image */}
      <section className="about-hero-section">
        <div className="about-hero-image">
          <img
            src={ourstory}
            alt="About Us - Cycle Rental"
            className="about-hero-img"
          />
        </div>
      </section>

      <section className="about-content-section">
        <div className="container">
          <div className="about-content-wrapper">
            <p className="about-description">
With over 45 years of experience in the cycling industry, we have built a strong reputation for quality, reliability, and customer trust. As authorized dealers of leading bicycle brands and genuine spare parts, we offer a comprehensive range of products to meet the needs of cyclists of all ages and skill levels. Our long-standing presence in the market reflects our commitment to providing customers with authentic products, expert guidance, and exceptional service.
            </p>

            <p className="about-mission">
Our service team consists of highly skilled technicians who are certified by Shimano and bring more than 15 years of professional bicycle servicing experience. From routine maintenance and performance tuning to complex repairs and component upgrades, our technicians ensure that every bicycle receives the highest standard of care. Their extensive expertise, combined with ongoing training and industry knowledge, enables us to deliver professional, reliable, and efficient service that helps cyclists enjoy a safe, smooth, and optimal riding experience.            </p>

            
          </div>
        </div>
      </section>

      

      <section className="cta-section-two-same">
        <div className="container">
          <h2 className="section-title-two-same">
             You are just one step away 
          </h2>
          <p className="cta-subtitle-two-same">
            from getting started on your cycling journey Book Your Cycle   
          </p>
          <Link to="/products" className="cta-button-two-same">
            Book Now →
          </Link>
        </div>
      </section>

      <section className="story-section">
        <div className="story-overlay"></div>
        <div className="container">
          <div className="story-content">
            <h2 className="story-title">Let's have a Chat</h2>

            <div className="story-contact">
              <div className="story-contact-item">
                <Phone size={20} />
                <a href="tel:+918082080816">+91 8082080816</a>
              </div>
              <div className="story-contact-item">
                <Mail size={20} />
                <a href="mailto:info@cyclerentalservices.com">info@cyclerentalservices.com</a>
              </div>
            </div>

<form className="story-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <User size={18} className="form-icon" />
                <input 
                  type="text" 
                  placeholder="Full Name" 
                  value={formData.name}
                  required
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                />
              </div>

              <div className="form-group">
                <Smartphone size={18} className="form-icon" />
                <input 
                  type="tel" 
                  placeholder="Mobile Number" 
                  value={formData.phone}
                  required
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                />
              </div>

              <div className="form-group">
                <Mail size={18} className="form-icon" />
                <input 
                  type="email" 
                  placeholder="Email" 
                  value={formData.email}
                  required
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                />
              </div>

              <div className="form-group">
                <MessageCircle size={18} className="form-icon" />
                <input 
                  type="text" 
                  placeholder="What are you looking for?" 
                  value={formData.inquiry}
                  onChange={(e) => setFormData({...formData, inquiry: e.target.value})}
                />
              </div>

              <button type="submit" className="story-submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
